
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The ECL v2 is the Commission's design system, created with a set of guiding principles that followed throughout the process.`}</p>
    <p>{`By following a user-centred design approach, the ECL is the result of in-depth research into the users' needs and goals, offering solutions that are assessed, tested and revised continuously.`}</p>
    <p>{`These solutions are then standardised to offer:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Vocabulary`}</strong>{`: a centralised UI promotes a shared understanding of components & terminology and thus fostering a collaborative flow across the organisation, regardless of discipline. This allows us to focus more on delivering, and less on back-and-forth communications`}</li>
      <li parentName="ul"><strong parentName="li">{`Consistency`}</strong>{`: increase page performance by decreasing design inconsistencies. By offering our users layouts, components, symbols (icons) and general visual properties they are already familiar with, a consistent design system will decrease confusion and learning curves, while offering predictable patterns of user experience with recognisable interactions`}</li>
      <li parentName="ul"><strong parentName="li">{`Re-usability and Flexibility`}</strong>{`: already existing UI sub-components pieces can be reused to roll out new features or rearranged into new components. A flexible and adaptable system to the future needs of the organisation that simplifies the processing of requesting components features, fixing bugs and improving documentation`}</li>
      <li parentName="ul"><strong parentName="li">{`Accessibility`}</strong>{`: given our broad audience, our content needs to be accessible to everyone. For this reason ECL follows inclusive design principles, regardless of ability, environment or situation`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;